import React from "react";
import ReactPaginate from "react-paginate";

interface IBasePaginationReactComponentProps {
    readonly pageCount?: number;
    readonly onPageChange?: (page: { selected: number }) => void;
}

export class BasePaginationReact extends React.Component<IBasePaginationReactComponentProps> {
    constructor(props: IBasePaginationReactComponentProps) {
        super(props);
    }

    public render() {
        const { pageCount, onPageChange } = this.props;

        return (
            <div className="ml-auto align-self-center">
                <ReactPaginate
                    previousLabel={"<"}
                    nextLabel={">"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount!}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={2}
                    onPageChange={onPageChange}
                    containerClassName={"justify-content-end mb-0 rounded-0 pagination pagination-sm"}
                    activeClassName={"active"}
                    disabledClassName={"disableButton"}
                />
            </div>
        );
    }
}

export { BasePaginationReact as Unconnected };
export default BasePaginationReact;
